export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('dropzone', {
    mounted(el, binding) {
      el.__dropzoneHandler = (event: any) => {
        const isInsideRect = function(){
          const rect = el.getBoundingClientRect();
          return (
            event.detail.clientX >= rect.left &&
            event.detail.clientX <= rect.right &&
            event.detail.clientY >= rect.top &&
            event.detail.clientY <= rect.bottom
          );
        }()

        if (isInsideRect) {
          binding.value({
            element: event.detail.element,
            clientX: event.detail.clientX,
            clientY: event.detail.clientY
          })
        }
      }

      document.addEventListener('draggable-drop', el.__dropzoneHandler)
    },
    unmounted(el) {
      document.removeEventListener('draggable-drop', el.__dropzoneHandler)
      delete el.__dropzoneHandler
    }
  })
})
